import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../app/store';
import { classNames } from '../../../utils/classNames';
import { useSignInWithAgentMutation } from '../../../store/auth/authApi';
import { useNavigate } from 'react-router-dom';
import TypingMessage from '../../../components/shared/typing-message/TypingMessage';
import { useSignUpWithAgentMutation } from '../../../store/user/userApi';
import { toNaiveISO } from '../../../utils/date';

const ChatContent = ({
	type = 'sign-up'
}: {
	type?: 'sign-up' | 'sign-in'
}) => {
	const navigate = useNavigate();

	const [signInAgent] = useSignInWithAgentMutation()
	const [signUpAgent] = useSignUpWithAgentMutation()
	const {authMessages, error} = useSelector(
		(state: RootState) => state.chats
	);

	const getAuthSignInMessages = (usedBefore?: boolean) => {
		if (type === 'sign-up') {
			signUpAgent({chatData: []}).unwrap();
		} else {
			signInAgent({chatData: []}).unwrap();
		}
	}

	const chatEndRef = useRef<HTMLDivElement>(null);
	const scrollToBottom = () => setTimeout(() => chatEndRef.current?.scrollIntoView({ behavior: 'smooth' }), 100)

	useEffect(() => {
		getAuthSignInMessages()
	},[]);

	useEffect(() => {
		if (authMessages?.find(message => message?.agent?.stage === 'authenticated')) {
			setTimeout(()=>{
				navigate('/')
			}, 500)
		}
		scrollToBottom();
	},[authMessages]);


	return (
		<div className='h-[70vh] md:h-[60vh] w-full overflow-auto bg-gray-100 p-5 flex flex-col'>
			{authMessages?.map(
				(conversation, index: number) => (
					<div key={conversation?.agent?.message || conversation?.user?.message + conversation?._id + index}  className='my-2 flex'>
						{conversation?.agent ? 
						<div className='w-full flex flex-row'>
							<img alt='avatar' width={34} height={34} className='rounded-full mr-2' src='/svg/auth/avatar.svg' />
							<div className='bg-white max-w-[90%] rounded-2xl p-4'>
								{conversation?.agent?.message && <TypingMessage isLogin={true} scrollToBottom={scrollToBottom} message={conversation?.agent?.message} typingSpeed={500} updatedAt={toNaiveISO()} />}
							</div>
						</div>
						: 
						<div className={classNames('bg-primary-default max-w-[90%] text-white rounded-2xl p-4 ml-auto break-words',
						 conversation?.user?.type === 'pending' ? 'opacity-50': '',
						 conversation?.user?.type === 'error' ? 'border-2 border-red-500 opacity-60': ''
						)}
						 >
							{conversation?.user?.message}
						</div>
				}
					</div>
				)
			)}
			<p className='text-red-400'>{error}</p>
			<div ref={chatEndRef} />
		</div>
	)
}

export default ChatContent;